<template id="exit-card">

    <div>   
     <!-- {{ actions }} -->


            <div v-if="btn_label!=''" class="exitbox">
                <div class="headerbox" :class="type">
                    <div v-if="type == 'new'" class="offer">Nuova attivazione</div>
                    <div v-else class="offer">Link</div>
                    <!--  -->
                    <div class="supply">{{ supply }}</div>
                </div>
                <div class="bodybox">
                    <!-- <div v-if="payment=='bollettino'" class="text" v-html="text_bollettino"></div> -->
                    <div class="text" v-html="text"></div>
                    <div class="text-docs" v-html="text_docs"></div>
                    <!-- <button @click="goToUrl(btn_url)">{{ btn_label }}</button> -->
                    <button @click="goTo(btn_url)">{{ btn_label }}</button>
                    <!-- <div>{{ btn_url }}</div> -->
                </div>
            </div>

            <div v-else :class="[total_ko ? 'exitbox plain exitbox-ko' : 'exitbox plain' ]" class="">
                <div class="bodybox">
                    <span v-if="total_ko" class="icon big icon-thankyoupage_failed"></span>
                    <div class="text" v-html="text"></div>
                </div>
            </div>

            <div v-if="underbox_title!=''" class="underbox-title" v-html="underbox_title"></div>
            <div v-if="underbox_text!=''" class="underbox-text" v-html="underbox_text"></div>
            
    </div>


</template>

<script>
export default {
    template: '#exit-card',

    props: ['exitlist', 'payment', 'commodity', 'type', 'supply', 'text', 'text_docs', 'btn_label', 'btn_url', 'underbox_title', 'underbox_text', 'event_category', 'total_ko'],

    data: function () {
        return {
            value: -1
        };
    },
    created: function () { 

    },

    mounted: function () { 
        
        console.log( 'ExitCard mounted supply: ', this.supply );
        console.log( 'ExitCard mounted event_category: ', this.event_category );
    },

    methods: {

        trackExitClick: function( event_category ) {

            console.log( 'ExitCard trackExitClick supply: ', this.supply );
            
            var commodity_eventLabel;

            if (this.supply == "Gas e Luce") {
                commodity_eventLabel = "dual";
            } else {
                commodity_eventLabel = this.supply.toLowerCase();
            }

            console.log( 'ExitCard trackExitClick commodity_eventLabel: ', commodity_eventLabel );

            
            try {
                console.log( 'ExitCard trackExitClick event_category', event_category );

                //- track analytics ---
                window.callDataLayer({ 
                    event: "customEvent",
                    eventAction: "carrello_step",
                    eventCategory: event_category,
                    eventLabel: commodity_eventLabel,
                    //gtm.uniqueEventId: "??",
                });

                //- track content square ---
                //window._uxa = window._uxa || [];
                //window._uxa.push(['trackPageview', window.location.pathname+window.location.hash.replace('#','?__') + '?cs-offerta-link-luce-gas='+this.micro_step]);
            } catch (error) {
                // tracking is not ready
            }
        },



        goTo: function(url) {
            this.trackExitClick(this.event_category);
            window.location.href = url;
            console.log(url);
        }
    }
}
</script>